var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / General / Trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.25V5.5C7 4.39543 7.89543 3.5 9 3.5H11C12.1046 3.5 13 4.39543 13 5.5V6.25H15.5C15.9142 6.25 16.25 6.58579 16.25 7C16.25 7.41421 15.9142 7.75 15.5 7.75H15V15.5C15 16.6046 14.1046 17.5 13 17.5H7C5.89543 17.5 5 16.6046 5 15.5V7.75H4.5C4.08579 7.75 3.75 7.41421 3.75 7C3.75 6.58579 4.08579 6.25 4.5 6.25H7ZM8.5 6H11.5V5.5C11.5 5.22386 11.2761 5 11 5H9C8.72386 5 8.5 5.22386 8.5 5.5V6Z",
    fill: "#8E97A3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ffe0371c69e2aade199461f007d8cd74.svg";
export { ForwardRef as ReactComponent };